import { render, staticRenderFns } from "./ModalEECCClient.vue?vue&type=template&id=10c6a07b&"
import script from "./ModalEECCClient.vue?vue&type=script&lang=js&"
export * from "./ModalEECCClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports